import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { CloseIcon, FilterIcon } from 'air-icons';

import './FMToolbar.css';

@inject('translationsStore')
@observer
export default class FMToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { translationsStore } = this.props;
    return (
      <div className="FMToolbar">
        <span className="creationActions">

          <div className="FMToolbarButton" onClick={this.props.onCreate}>
            <div className="caption">
              {translationsStore.translate('fleetManagers.labelCreateFleetManager')}
            </div>
          </div>

        </span>
      </div>
    );
  }
}
